const DECIMAL_NUMBER_PATTERN = /^-?(?:\d+\.?\d*|\.\d+)$/;
export function parseFiniteNumber(value) {
    const trimmed = value.trim();
    if (!trimmed || !DECIMAL_NUMBER_PATTERN.test(trimmed)) {
        return undefined;
    }
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : undefined;
}
//# sourceMappingURL=parse-finite-number.js.map